import { GET_TNC_INFO, TNC_INFO_ERROR } from "../types";


const initialState = {
  tnc: {},
  loading: true,
};

export default function (state = initialState, action) {
  switch (action.type) {
    case GET_TNC_INFO:
      return {
        ...state,
        tnc: action.payload,
        loading: false,
      };
    case TNC_INFO_ERROR:
      return {
        ...state,
        loading: true,
      };

    default:
      return state;
  }
}
